import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-white" data-id="element-65">
      <div className="max-w-3xl mx-auto px-6" data-id="element-66">
        <motion.div className="bg-beige-light rounded-3xl p-8 md:p-12 border border-gold/30 text-center relative overflow-hidden" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          {/* Decorative background */}
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/60 via-transparent to-transparent pointer-events-none" data-id="element-68"></div>

          <div className="relative z-10" data-id="element-69">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white shadow-sm mb-6 text-gold" data-id="element-70">
              <ShieldCheck size={40} strokeWidth={1.5} data-id="element-71" />
            </div>

            <h2 className="text-2xl md:text-3xl font-serif text-navy mb-6" data-id="element-72">
              Garantía de satisfacción total — 7 días
            </h2>

            <p className="text-slate leading-relaxed max-w-xl mx-auto" data-id="element-73">
              Si en los próximos 7 días sentís que este sistema no es para vos,
              te devolvemos el 100% de tu dinero. Sin preguntas, sin
              complicaciones. Tu compra está protegida.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}